const comments = [
  {
    name: '吃瓜一线猹',
    avatar: '🦔',
    time: '3小时前',
    content: '这个爆料太震撼了！51吃瓜网址果然从来没让我失望过，每天必刷，感觉已经离不开51每日吃瓜的节奏了。编辑团队辛苦了，继续加油！',
    likes: '2.3万',
  },
  {
    name: '八卦小雷达',
    avatar: '🐱',
    time: '5小时前',
    content: '作为一个资深吃瓜群众，51吃瓜网今日吃瓜的内容质量是真的高，每一条都有来源标注，不像其他地方全是道听途说。支持专业吃瓜！',
    likes: '1.8万',
  },
  {
    name: '娱乐圈观察员',
    avatar: '🦊',
    time: '7小时前',
    content: '看了51吃瓜大赛的候选名单，真的每一条都是年度级别的。今年的投票竞争太激烈了，我已经连续投了三天，期待最终结果揭晓！',
    likes: '1.5万',
  },
  {
    name: '深夜吃瓜人',
    avatar: '🦉',
    time: '9小时前',
    content: '51吃瓜最新那条匿名爆料看得我睡不着了，如果下半年真的还有三个大瓜，那今年娱乐圈简直就是修罗场。已经设置好推送提醒，坐等后续！',
    likes: '1.2万',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            来自瓜友们的真实声音，每一条评论都是对吃瓜的热爱
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-[1000px] mx-auto">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-lg">
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-heart-line"></i>
                  {comment.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}